export const TOGGLE_GROUP_TEXT = {
  selectAll: '전체 선택',
  clearAll: '전체 해제',
} as const;
